import { Box, Grid, MenuItem, Paper, styled } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';

import { ReactComponent as MenuIcon } from '../../../../assets/icons/icon-menu.svg';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Menu, { MenuProps } from '@mui/material/Menu';
import { format } from 'date-fns';
import { ReactComponent as CrossCircleReadIcon } from '../../../../assets/icons/icon-cross-circle-red.svg';
import { ReactComponent as EditPencilOrange } from '../../../../assets/icons/icon-edit-pencil-orange.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/icon-search.svg';
import commons from '../../../../assets/styles/commons';
import useGetPrivateDrivers from '../../../../hooks/driver/useGetPrivateDrivers';
import { formatDateTime } from '../../../../utils/formatTime';
import ActivityIndicator from '../../../ActivityIndicator';
import ButtonComponent from '../../../atoms/button';
import CustomDataGrid from '../../../atoms/dataGrid';
import ItemsPerPageSelect from '../../../atoms/itemsPerPageSelect';
import Pagination from '../../../atoms/pagination';
import Typography from '../../../atoms/typography';
import StatusUser from '../users/components/status';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ModalCustom from '../../../atoms/modalCustom';
import useDeleteDistributor from '../../../../hooks/distributors/useDeleteDistributor';
import useDeletePrivateDriver from '../../../../hooks/driver/useDeletePrivateDriver';
import { useHistory } from 'react-router-dom';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import ModalDriver from '../../../../containers/Drivers/components/Modal';
import AssignmentIndOutlined from '@mui/icons-material/AssignmentTurnedInOutlined';

interface IRowDriversData {
  id: string;
  username: string;
  createdAt: string;
  cnhNumber?: string;
  cnhDueDate?: string;
  status: string;
  cpf?: string;
  phoneNumber?: string;
}

const StyledMenu = styled((props: MenuProps) => <Menu {...props} />)(
  ({ theme }) => ({
    '& .MuiPaper-root': {
      border: '1px solid #FF7206',
      borderRadius: 4,
      padding: 4,
    },
    '& .MuiList-root': {
      padding: '0px !important',
    },
    '& .MuiList-padding': {
      padding: '0px !important',
    },
  }),
);

const columns: GridColDef[] = [
  {
    field: 'username',
    flex: 4,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Nome completo
      </Typography>
    ),
    renderCell: (params: { row: IRowDriversData }) => (
      <Typography>{params.row.username}</Typography>
    ),
  },
  {
    field: 'createdAt',
    flex: 1,
    editable: false,
    sortable: false,
    valueFormatter: (params: any) => formatDateTime(params.value),
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Criado em
      </Typography>
    ),
    renderCell: (params: { row: IRowDriversData }) => (
      <Typography>{formatDateTime(params.row.createdAt)}</Typography>
    ),
  },
  {
    field: 'cnhNumber',
    flex: 1.5,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        CNH
      </Typography>
    ),
    renderCell: (params: { row: IRowDriversData }) => {
      if (!params.row?.cnhNumber) return;
      return (
        <Box display={'flex'} alignItems={'center'}>
          <Typography>{params.row.cnhNumber}</Typography>
          <Typography style={{ fontSize: 12 }} color="gray">
            ({params.row.cnhDueDate})
          </Typography>
        </Box>
      );
    },
  },
  {
    field: 'status',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Status
      </Typography>
    ),
    renderCell: (params: { row: IRowDriversData }) => (
      <StatusUser status={params.row.status} />
    ),
  },
];

interface IOptionsCellParams {
  editDriver: () => void;
  deleteDriver: () => void;
  validateDriver: () => void;
}

const OptionsCell: React.FC<IOptionsCellParams> = ({
  deleteDriver,
  editDriver,
  validateDriver,
}: IOptionsCellParams) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleValidateDriver = () => {
    handleClose();
    validateDriver();
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        aria-label="menu"
      >
        <MenuIcon />
      </IconButton>
      <StyledMenu
        id="basic-menu"
        sx={{
          border: '1px #FF7206 1px',
          borderRadius: 15,
          padding: 10,
        }}
        onClose={handleClose}
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          style={{ display: 'flex', gap: 15 }}
          onClick={handleValidateDriver}
        >
          <AssignmentIndOutlined sx={{ color: '#FF7206' }} />
          Validar
        </MenuItem>
        <MenuItem style={{ display: 'flex', gap: 15 }} onClick={editDriver}>
          <EditOutlinedIcon sx={{ color: '#FF7206' }} />
          Editar
        </MenuItem>
        <MenuItem onClick={deleteDriver} style={{ display: 'flex', gap: 15 }}>
          <CrossCircleReadIcon />
          Excluir
        </MenuItem>
      </StyledMenu>
    </Box>
  );
};

const PrivateDriversTable: React.FC = () => {
  const { execute, loading } = useGetPrivateDrivers();
  const history = useHistory();
  const { execute: executeDeleteDriver } = useDeletePrivateDriver();
  const [searchFilterInputValue, setSearchFilterInputValue] = useState('');
  const [driversPerPage, setDriversPerPage] = useState(10);
  const [openValidateDriverModal, setOpenValidateDriverModal] = useState(false);
  const [openConfirmDeletionModal, setOpenConfirmDeletionModal] =
    useState(false);
  const [closeOptionCell, setCloseOptionCell] = useState(false);
  const [rowDriversData, setRowDriversData] = React.useState<{
    page: number;
    totalRecords: number;
    rows: IRowDriversData[];
  }>();
  const userIdToDelete = useRef('');
  const [selectedDriverId, setSelectedDriverId] = useState<string | undefined>(
    undefined,
  );

  const loadUsers = async (page?: number, searchFilterValue?: string) => {
    const privetDrivers = await execute({
      page: page || rowDriversData?.page || 1,
      rowsPerPage: driversPerPage,
      searchFilter: searchFilterValue || undefined,
    });

    if (privetDrivers) {
      const formatedRows: IRowDriversData[] = privetDrivers.rows.map(row => {
        let driverLicenseFormatedDueDate = '';
        if (row.driverLicense?.driverLicenseExpiryDate) {
          driverLicenseFormatedDueDate = format(
            new Date(row.driverLicense.driverLicenseExpiryDate),
            'MM/yyyy',
          );
        }

        return {
          id: row.driverId,
          username: row.username,
          createdAt: row.createdAt,
          cnhNumber: row.driverLicense?.driverLicenseNumber
            ? row.driverLicense.driverLicenseNumber
            : '',
          cnhDueDate: driverLicenseFormatedDueDate,
          status: row.status,
          cpf: String(row.cpf),
          phoneNumber: String(row.phoneNumber),
        };
      });

      setRowDriversData({
        page: privetDrivers.page,
        totalRecords: privetDrivers.totalRecords,
        rows: formatedRows,
      });
      setSelectedDriverId(undefined);
    }
  };

  const confirmDriverDelation = (userId: string) => {
    setOpenConfirmDeletionModal(true);
    userIdToDelete.current = userId;
  };

  const deleteDriver = () => {
    executeDeleteDriver(userIdToDelete.current, () => {
      setOpenConfirmDeletionModal(false);
      loadUsers();
    });
  };

  const validateDriver = (driverId: string) => {
    setSelectedDriverId(driverId);
    setCloseOptionCell(true);
    setOpenValidateDriverModal(true);
  };

  const handleSetModal = (value: boolean) => {
    if (!value) {
      loadUsers();
      setOpenValidateDriverModal(false);
    } else {
      setOpenValidateDriverModal(true);
    }
  };
  const goToUpdateDriverFormScreen = (
    driverRowData: GridRenderCellParams<any, IRowDriversData>,
  ) => {
    const formatedDriver = {
      id: driverRowData.row.id,
      username: driverRowData.row.username,
      cpf: driverRowData.row.cpf,
      phoneNumber: driverRowData.row.phoneNumber,
    };

    history.push('/home/private-drivers/edit', {
      driver: formatedDriver,
    });
  };

  const goToCreateDriversForm = () => {
    history.push('/home/private-drivers/create');
  };

  useEffect(() => {
    loadUsers();
  }, [driversPerPage]);

  return (
    <Box
      style={{
        border: '1px solid #E4E9F2',
        borderRadius: 4,
        padding: 16,
      }}
      component="div"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Paper
          component="form"
          elevation={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            border: '1px solid #FF7206',
            backgroundColor: '#F7F9FC',
            flex: 1,
            marginRight: 20,
          }}
          onSubmit={event => {
            event.preventDefault();
          }}
        >
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              fontFamily: commons.fontFamily,
            }}
            placeholder="Buscar motorista"
            type="text"
            onChange={event => {
              setSearchFilterInputValue(event.target.value);
            }}
            className="input-filter"
            value={searchFilterInputValue}
            inputProps={{ maxLength: 30 }}
          />
          <IconButton
            type="submit"
            sx={{ p: '10px' }}
            aria-label="Pesquisar"
            onClick={() => {
              loadUsers(rowDriversData?.page, searchFilterInputValue);
            }}
          >
            <SearchIcon />
          </IconButton>
        </Paper>

        <ButtonComponent theme="primary" mb={5} onClick={goToCreateDriversForm}>
          <FontAwesomeIcon icon={solid('plus')} size="sm" color="#fff" /> Novo
          motorista
        </ButtonComponent>
      </Box>
      {loading ? (
        <ActivityIndicator />
      ) : (
        <>
          <CustomDataGrid
            columns={[
              ...columns,
              {
                field: 'actions',
                flex: 1,
                editable: false,
                sortable: false,
                renderHeader: () => (
                  <Typography color="gray" fontWeight="700">
                    Ação
                  </Typography>
                ),
                renderCell: params => (
                  <OptionsCell
                    deleteDriver={() =>
                      confirmDriverDelation(String(params.id))
                    }
                    editDriver={() => goToUpdateDriverFormScreen(params as any)}
                    validateDriver={() => validateDriver(String(params.id))}
                  />
                ),
              },
            ]}
            rows={rowDriversData?.rows || []}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            pageSize={20}
          />
          <hr />
        </>
      )}
      <Grid container justifyContent="space-between">
        <Grid item>
          <ItemsPerPageSelect
            label={'Mostrar'}
            value={driversPerPage}
            onChange={(row: number) => {
              setDriversPerPage(row);
            }}
          />
        </Grid>
        <Grid item>
          <Pagination
            currentPage={rowDriversData?.page as number}
            totalRecords={rowDriversData?.totalRecords as number}
            setCurrentPage={(page: number) => {
              loadUsers(page);
            }}
            rowsPerPage={driversPerPage}
          />
        </Grid>
      </Grid>

      <ModalDriver
        openModal={openValidateDriverModal}
        setOpenModal={handleSetModal}
        stepsToValidate={3}
        driverId={selectedDriverId as string}
      />

      <ModalCustom
        open={openConfirmDeletionModal}
        onCancelClick={() => setOpenConfirmDeletionModal(false)}
        onClickPublish={deleteDriver}
        ButtonOutlinePrimary="Cancelar"
        ButtonPrimary="Confirmar"
        alignCenter={true}
        hideCloseIcon={true}
        label="Deseja excluir o acesso deste motorista?"
        boxStyle={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          gap: 2,
        }}
      />
    </Box>
  );
};

export default PrivateDriversTable;
